'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genericDefaultProps = exports.genericPropTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var genericPropTypes = exports.genericPropTypes = {
  text: _propTypes2.default.string,
  value: _propTypes2.default.any,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string.isRequired,
  errors: _propTypes2.default.array
};

var genericDefaultProps = exports.genericDefaultProps = {
  disabled: false,
  required: false,
  className: '',
  onChange: function onChange() {
    throw new Error('You must define an onChange for inputs');
  },
  errors: []
};


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/utils.js
// module id = 95
// module chunks = 0